// app.js
"use strict";

import angular from "angular";
import { autofocusDirective } from "./autofocus.directive";

const AUTOFOCUS =  angular
    .module("inetumAutofocus", [])
    .directive("inetumAutofocus", autofocusDirective)
    ;

export { AUTOFOCUS };
